const resizedCustomAvatarUrl = (firebasestorageUrl, dimentionsSuffix) => {
  const indexOfLastPeriod = firebasestorageUrl.lastIndexOf('.');
  const pathAndFilename = firebasestorageUrl.substring(0, indexOfLastPeriod);
  const extensionAndParams = firebasestorageUrl.substring(indexOfLastPeriod, firebasestorageUrl.length);
  return `${pathAndFilename}_${dimentionsSuffix}${extensionAndParams}`;
};

export default resizedCustomAvatarUrl;
